import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';

export const useTransferStyles = createStyles(
  ({ token }, { noHorizontal, view } = {}) => ({
    transferHeader: {
      color: ThemeColors.COLOR_GREY_BLUISH3,
      boxShadow: 'rgba(0, 0, 0, 0.35) 0px 1px 10px inset',
      lineHeight: '30px',
      paddingLeft: 10,
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontWeight: 700,
      backgroundColor: ThemeColors.COLOR_GREY_DARK2_7,
      borderBottom: `1px solid ${ThemeColors.COLOR_GREY3_5}`,
      borderTop: `1px solid ${ThemeColors.COLOR_BLACK2}`,

      '.ant-checkbox': {
        marginRight: 15,
      },

      '.ant-checkbox-wrapper': {
        color: ThemeColors.COLOR_GREY_BLUISH3,
        fontSize: 14,
        fontWeight: 700,
      },
    },
    transferRow: {
      padding: `0 ${ThemeSpaces.SPACE_NORM_20}px`,
      color: ThemeColors.COLOR_GREY_BLUISH3_2,
      fontFamily: token.fontFamily,
      fontWeight: 400,
      lineHeight: '39px',
      borderBottom: `1px solid ${ThemeColors.COLOR_BLACK2}`,

      '.ant-checkbox': {
        marginRight: 20,
      },

      '.ant-checkbox-wrapper': {
        color: ThemeColors.COLOR_GREY_BLUISH3_2,
        fontSize: 14,
        fontWeight: 400,
      },
    },
    transferRowAlt: {
      borderBottom: `1px solid ${ThemeColors.COLOR_GREY_DARK2_8}`,
    },
    solidDivider: {
      backgroundColor: ThemeColors.COLOR_GREY_DARK2_8,
      height: 10,
      borderTop: `1px solid ${ThemeColors.COLOR_GREY3_5}`,
      borderBottom: `1px solid ${ThemeColors.COLOR_BLACK2}`,
      position: 'relative',
      flexShrink: 0,

      '&::before': {
        content: '" "',
        borderTop: `1px solid ${ThemeColors.COLOR_BLACK2}`,
        position: 'absolute',
        left: 0,
        right: 0,
        top: -2,
      },
    },
    transferSectionAutoHeight: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',

      [`.${noHorizontal} .${view}`]: {
        maxHeight: '100% !important',
      },
    },
    transferSectionScrollbars: {
      overflow: 'hidden',
      display: 'flex',
      flexGrow: 1,

      [`.${noHorizontal}`]: {
        flexGrow: 1,
      },
    },
    transferSectionFixed: {
      display: 'flex',
      flexDirection: 'column',
    },
  })
);
